import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    paddingBottom: '5px',
    '& .MuiTypography-button': {
      paddingTop: '3px',
      fontSize: '0.74rem',
    },
  },
}));

export default useStyles;
